import { Input, Component } from '@angular/core';
import { Router } from '@angular/router';
import { JobStub } from '../../core-data-model/Job/JobStub.model';
import { Person } from '../../core-data-model/Person.model';
import { SearchResult } from '../../core-data-model/SearchResult.model';
import { SiteNavigationService } from '../../core-services/SiteNavigation.service';

@Component({
    selector: 'result-link',
    template: `
        @if (displayString !== undefined && displayString !== null) {
            <a class="lsg-link" [routerLink]="url" (click)="onNavigate($event)">
                {{ displayString }}
            </a>
        }
    `,
    standalone: false
})
export class NewTableLinkComponent {
    @Input()
    result: SearchResult;

    get displayString() {
        if (this.result instanceof Person) {
            return this.result.fullName(true);
        } else if (this.result instanceof JobStub) {
            return this.result.title;
        }
    }

    constructor(
        private router: Router,
        private siteNavigationService: SiteNavigationService
    ) {}

    get url(): string {
        const pathArray =
            this.result instanceof Person ? this.personUrl : this.jobUrl;
        return this.router.createUrlTree(pathArray).toString();
    }

    get personUrl(): string[] {
        const p = this.result as Person;
        return p.personDetails_route;
    }
    get jobUrl(): string[] {
        return ['/job', this.result.id];
    }

    onNavigate(event: Event) {
        event.stopImmediatePropagation();
        event.preventDefault();
    }
}
